import { roundDecimals } from '@/addons/adjustments'
import { TipiMovimenti, TipiVendita } from '@/addons/enums'
import { ApiV1SalesDataAttributesPagamenti } from '@/api'
import {
  AlterationsTab,
  AlterationsTabItem,
  GetAlterationPricesDataAttributes,
} from '@/interfaces/tailoring'

export function convertAlterations(alterationsTabs: AlterationsTab[]) {
  let price = 0
  return alterationsTabs.reduce(
    (
      outputAlterations: GetAlterationPricesDataAttributes[],
      alterationTab: AlterationsTab,
      currentIndex: number,
    ) => {
      const isReturn =
        alterationTab.cod_movimento === TipiVendita.STORNO ||
        alterationTab.cod_movimento === TipiVendita.RESO
      const currentTabAlterations = alterationTab.alterations
        .filter((alteration: AlterationsTabItem): boolean => {
          if (
            ('customPrice' in alteration &&
              (typeof alteration.customType !== 'string' ||
                alteration.customType.length < 5)) ||
            (alteration.attributes.progressivo === '99' &&
              'customPrice' in alteration === false)
          ) {
            return false
          }

          return alteration.isSelected
        })
        .map(
          (
            alteration: AlterationsTabItem,
          ): GetAlterationPricesDataAttributes => {
            if (alteration.customPrice) {
              price = isReturn
                ? Math.abs(alteration.customPrice) * -1
                : Math.abs(alteration.customPrice)
            } else if (alteration.attributes.importo) {
              price = isReturn
                ? Math.abs(alteration.attributes.importo) * -1
                : Math.abs(alteration.attributes.importo)
            } else {
              price = 0
            }

            return {
              classe: alteration.attributes.classe,
              idAlterationTab: alterationTab.alterationGroupId,
              cod_negozio: alteration.attributes.cod_negozio,
              data_modifica: alteration.attributes.data_modifica,
              additionalNotes: alterationTab.additionalNotes,
              calendarValue: alterationTab.calendarValue,
              descrizione:
                alteration.customType && alteration.customType !== ''
                  ? alteration.customType
                  : alteration.attributes.descrizione,
              importo: price,
              importo_finale: alteration.hasPrice ? price : 0,
              progressivo: alteration.attributes.progressivo,
              gruppo: currentIndex + 1,
              cod_movimento: alterationTab.cod_movimento,
              vat: alterationTab.vat,
            }
          },
        )

      return outputAlterations.concat(currentTabAlterations)
    },
    [] as GetAlterationPricesDataAttributes[],
  )
}

export function alterationToPaymentData(
  alteration: GetAlterationPricesDataAttributes,
  vat_percentage?: number,
  venditrice?: string,
): ApiV1SalesDataAttributesPagamenti {
  return {
    cod_negozio: alteration.cod_negozio,
    idAlterationTab: alteration.idAlterationTab,
    cod_operazione: alteration.progressivo,
    codice_movimento: ((): TipiMovimenti => {
      if (alteration.importo === 0 || alteration.importo_finale === 0) {
        return TipiMovimenti.CONTABILITA_SARTORIA_OMAGGIO
      }
      return TipiMovimenti.CONTABILITA_SARTORIA
    })(),
    dati_operazione: JSON.stringify({
      tipo: 'VENDITA',
      nota_lavorazioni: alteration.additionalNotes,
      data_consegna_sartoria: alteration.calendarValue,
      iva: alteration.vat ? alteration.vat : (vat_percentage ?? 0),
      descrizione: alteration.descrizione,
      classe: alteration.classe,
      rdv: venditrice,
      gruppo:
        typeof alteration?.gruppo === 'number'
          ? alteration?.gruppo.toString()
          : alteration?.gruppo,
      cod_movimento: alteration.cod_movimento,
    }),
    divisa: undefined,
    id_postazione: undefined,
    importo_finale: roundDecimals(alteration.importo_finale || 0),
    importo_iniziale: roundDecimals(alteration.importo),
    progressivo_capo: 0,
    tipo_applicazione: 'POSWEB',
  }
}

export function mapAlterationTabsToPayments(
  alterationsTabs: AlterationsTab[],
  vat_percentage?: number,
  venditrice?: string,
): ApiV1SalesDataAttributesPagamenti[] {
  const alterations = convertAlterations(alterationsTabs)

  return alterations.map((alteration: GetAlterationPricesDataAttributes) =>
    alterationToPaymentData(alteration, vat_percentage, venditrice),
  )
}

export function simplifiedPaymentData(data) {
  return data.map((payment) => ({
    importo_finale: payment.importo_finale,
    importo_iniziale: payment.importo_iniziale,
    cod_operazione: payment.cod_operazione,
    codice_movimento: payment.codice_movimento,
    idAlterationTab: payment.idAlterationTab,
  }))
}
